import MessageMobileContainer from './MessageMobileContainer';

export default MessageMobileContainer;
